const technicalSuccessMessages = new Set([
  "request successful",
]);

export const isUserFacingSuccessMessage = ( message?: string ) => {
  const normalizedMessage = message?.trim().toLowerCase() ?? "";

  return normalizedMessage !== "" && !technicalSuccessMessages.has( normalizedMessage );
};
